module.exports = __webpack_public_path__ + "media/images/icons/call-c7fef0fd766436be70c765583188a693.png";